import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
    cep: '',
    endereco: '',
    esperandoSolicitacao: false,
    currentPage : 0,
    agencia: {},
    municipios: [],
    municipio: null,
    gerencias: {},
    redirectUrl: '',
    agencias: [],
    abaSelecionada: 0,
    erro: false,
    mensagem: '',
    tipoError: null,
    agenciasFiltradas: []
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type){

        case 'LOCALIZADOR_AGENCIAS_RECEBIDAS':
            return { ...state, esperandoSolicitacao: false, agencias: action.payload };

        case 'LOCALIZADOR_AGENCIA_SOLICITADA':
            return { ...state, esperandoSolicitacao: true, redirectUrl: null };

        case 'LOCALIZADOR_VALOR_CEP_ATUALIZADO':
            return {...state, cep: action.payload, esperandoSolicitacao: false, erro: false, mensagem: ''};

        case 'LOCALIZADOR_AGENCIA_SOLICITADO':
            return {...state, esperandoSolicitacao: true};

        case 'LOCALIZADOR_AGENCIA_POR_CEP_RECEBIDO':
            return {...state, agencia: {...state.agencia, [action.payload.apsTO.codigo]: action.payload}, 
                redirectUrl: '/localizador-aps/agencia/' + action.payload.apsTO.codigo, esperandoSolicitacao: false, erro: false};

        case 'LOCALIZADOR_AGENCIA_POR_CODIGO_RECEBIDO':
            return {...state, agencia: {...state.agencia, [action.payload.apsTO.codigo]: action.payload}, esperandoSolicitacao: false, erro: false};

        case 'LOCALIZADOR_ERRO_RECEBIDO':
            return {...state, esperandoSolicitacao: false, 
                mensagem: (typeof action.payload == "string") ? action.payload : MSG_ERRO_SERVIDOR, erro: true, esperandoSolicitacao: false, tipoError: 'SERVER_ERROR'}

        case 'LOCALIZADOR_MENSAGEM_ERRO_LIMPA':
            return {...state, mensagem: '', agencias: {}, erro: false, tipoError: null};

        case 'LOCALIZADOR_RESET_REDIRECT':
            return {...state, redirectUrl: undefined};

        case 'LOCALIZADOR_GERENCIA_SOLICITADA':
            return {...state, esperandoSolicitacao: true, erro: false, mensagem: ''};

        case 'LOCALIZADOR_GERENCIA_RECEBIDA':
            return {...state, gerencias: {...state.gerencias, [action.payload.idUO]: action.payload}, esperandoSolicitacao: false, erro: false, mensagem: ''};

        case 'LOCALIZADOR_UFS_RECEBIDOS':
            return {...state, ufs: action.payload.unidadeFederacaoTO};
        
        case 'LOCALIZADOR_VALOR_UF_ATUALIZADO':
            return {...state, uf: action.payload, municipios: [], municipio: null};

        case 'LOCALIZADOR_MUNICIPIOS_RECEBIDOS':{
            let municipios = Array.isArray(action.payload.municipioTO) ? action.payload.municipioTO : [action.payload.municipioTO];
            return {...state, municipios}
        }
        case 'LOCALIZADOR_VALOR_MUNICIPIO_ATUALIZADO':
            return {...state, municipio: action.payload}

        case 'LOCALIZADOR_VALOR_MUNICIPIO_LIMPO':
            return {...state, municipio: null};

        case 'LOCALIZADOR_AGENCIAS_POR_ENDERECO_RECEBIDO':
            return {...state, agencias: action.payload.data, esperandoSolicitacao: false, erro: false, mensagem: '' }

         case 'LOCALIZADOR_AGENCIAS_POR_CODIGO_ENDERECO_RECEBIDO':
            return {...state, agencias: action.payload, esperandoSolicitacao: false, erro: false, mensagem: ''}

        case 'LOCALIZADOR_VALOR_ENDERECO_ATUALIZADO':
            return {...state, endereco: action.payload}

        case 'LOCALIZADOR_TAB_ATUALIZADO':
            return {...state, currentPage: action.payload}        
        
        case 'LOCALIZADOR_AGENCIAS_FILTRADAS_RECEBIDAS':
            return {...state, agenciasFiltradas: action.payload, esperandoSolicitacao: false, erro: false, mensagem: ''};

        case 'LOCALIZADOR_SELECIONAR_ABA':
            const novaAba = action.payload;
            const abaAnterior = state.abaSelecionada
            const limpar = novaAba !== abaAnterior;

            return{...state, abaSelecionada: novaAba,...(limpar && {cep:'',endereco: '', uf: '', municipio: null, agencia:[], mensagem: '', erro: false, esperandoSolicitacao: false,})}            
        case 'LOCALIZADOR_AGENCIAS_POR_MUNICIPIO_FILTRADAS_RECEBIDAS':
            return {...state, agencias: action.payload, esperandoSolicitacao: false};
        case 'LOCALIZADOR_FORMULARIO_LIMPO':
            return {...state, cep: '', endereco: '', uf: '', municipio: null, agencias: [], mensagem: '', erro: false, esperandoSolicitacao: false};
        case 'LOCALIZADOR_NAO_ENCONTRADO':
            return {...state, esperandoSolicitacao: false, erro: true, mensagem: 'not_found', tipoErro: 'NOT_FOUND'}
        default:
            return state;
    }
}